import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=6a850574&"
import script from "./NewsMain.vue?vue&type=script&lang=js&"
export * from "./NewsMain.vue?vue&type=script&lang=js&"
import style0 from "./NewsMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a850574')) {
      api.createRecord('6a850574', component.options)
    } else {
      api.reload('6a850574', component.options)
    }
    module.hot.accept("./NewsMain.vue?vue&type=template&id=6a850574&", function () {
      api.rerender('6a850574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/News/NewsMain.vue"
export default component.exports